export const SpsDatetimeRangePickerExamples = {
    basic: {
        label: "Basic",
        description: `<p>Datetime range picker</p>`,
        examples: {
            basic: {
                template: `
                    <form [formGroup]="form">
                        <div class="row">
                            <div class="col-8">
                                <sps-datetime-range-picker formControlName="datetimeRange"
                                id="datetimeRangeBasic"></sps-datetime-range-picker>
                            </div>
                        </div>
                        <br />
                        selected date range (serialized from moment objects):<br />
                        {{ form.get("datetimeRange").value | json }}
                    </form>
                `,
                class: `
                    class DemoComponent {
                        form: FormGroup;
                        constructor(fb: FormBuilder) {
                            this.form = fb.group({
                                datetimeRange: []
                            });
                        }
                    }
                `
            }
        }
    },
};
